window.custom = window.custom || {};

// Assign the BackToTop object to window.custom
window.custom.BackToTop = {
  button: null,
  scrollThreshold: 20,

  init() {
    this.button = document.getElementById("backToTopBtn");
    if (!this.button) {
      return;
    }

    window.addEventListener("scroll", this.handleScroll.bind(this));
    this.button.addEventListener("click", this.scrollToTop.bind(this));
  },

  handleScroll() {
    if (!this.button) return;

    if (
      document.body.scrollTop > this.scrollThreshold ||
      document.documentElement.scrollTop > this.scrollThreshold
    ) {
      this.showButton();
    } else {
      this.hideButton();
    }
  },

  showButton() {
    this.button.style.display = "block";
  },

  hideButton() {
    this.button.style.display = "none";
  },

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};


// Initialize the BackToTop object
window.custom.BackToTop.init();
